import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const articleVideo = {
  createArticleFromVideo: lazyModuleMethod(
    () => import('./createArticleFromVideo'),
    'default'
  ),
}
